var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "modal-card" }, [
    _c("header", { staticClass: "modal-card-head" }, [
      _c("p", { staticClass: "modal-card-title" }, [
        _vm._v(" Delete Profile "),
      ]),
      _c(
        "a",
        {
          staticClass: "close-modal",
          attrs: { "aria-label": "close" },
          on: {
            click: function ($event) {
              return _vm.closeModal()
            },
          },
        },
        [_c("i", { staticClass: "material-icons" }, [_vm._v("close")])]
      ),
    ]),
    _c("section", { staticClass: "modal-card-body" }, [
      _c("p", [
        _vm._v(" Are you sure you want to delete the profile called "),
        _c("strong", [_vm._v(_vm._s(_vm.profileToDelete.name))]),
      ]),
      _c("div", { staticClass: "buttons-row" }, [
        _c(
          "button",
          {
            staticClass: "button button-secondary button-outline button-medium",
            on: {
              click: function ($event) {
                return _vm.closeModal()
              },
            },
          },
          [_vm._v(" Cancel ")]
        ),
        _c(
          "button",
          {
            staticClass: "button button-primary button-medium",
            attrs: { disabled: _vm.deleteLoading },
            on: {
              click: function ($event) {
                return _vm.deleteProfile()
              },
            },
          },
          [_vm._v(" Delete ")]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }